@if (!selectedRegionId) {
  <div class="region-list">
    <h3>{{regions.length}} Regions in {{countryName}}</h3>
    <div class="region-list__content">
      <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
        <div class="swiper-wrapper">
          @for(region of regions; track region.region_id; let idx = $index) {
            <div class="swiper-slide">
              <app-region-card-mobile
                      [region]="region"
                      [countryName]="countryName"
                      (onShowCities)="handleShowCities($event)"
                      (onHideCities)="handleHideCities($event)"
              ></app-region-card-mobile>
            </div>
          }
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
}

@if (selectedRegionId === 'fetching') {
  <app-city-list-mobile
    [countryName]="countryName"
  ></app-city-list-mobile>
}

@if (visibleCities && visibleCities.size) {
  @for (region of visibleCities; track region.place_id) {
    <app-city-list-mobile
       [countryName]="countryName"
       [region]="region"
    ></app-city-list-mobile>
  }
}
